/* eslint-disable @typescript-eslint/no-empty-interface */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
